import React from "react";
import { LegacyCard as Card, Checkbox, FormLayout, Select, InlineStack, TextField, BlockStack } from "@shopify/polaris";

import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";
import { renderDetail } from "app/shipping/modules/provider/features/subFeatures/advance/offers/propsType";

const RenderOfferDetail = (props) => {
  const { FIXED, FREE } = constant;
  const {
    isCumulative,
    handleCost,
    handleDescription,
    handleType,
    priceType,
    description,
    toggleCumulativeShipping,
    isOrderValue,
    moneyFormat,
    priceValue,
    cms,
  } = props;

  const options = [
    { label: cms("label.fixed"), value: FIXED },
    { label: cms("label.freeShipping"), value: FREE },
  ];

  const acceptOnlyValidInput = (value, prevValue) => {
    return (baseHelper.validatePositiveNumericValues(value) && value) || (value !== "" && prevValue) || "";
  };

  return (
    <Card title={cms("modal.offer.add.section.product.label.offerDetails")} sectioned>
      <BlockStack gap="400">
        <TextField
          label={`${cms("modal.offer.add.section.detail.label.description")}*`}
          placeholder={`${cms("modal.offer.add.section.detail.placeholder.description")} *`}
          value={description}
          onChange={handleDescription}
        />

        <InlineStack gap="400">
          <Select
            label={`${cms("modal.offer.add.section.detail.label.selectShippingType")} *`}
            options={options}
            onChange={handleType}
            placeholder={cms("modal.offer.add.section.detail.placeholder.selectShipping")}
            value={priceType}
          />
          {priceType === FIXED && (
            <TextField
              label={`${cms("modal.offer.add.section.detail.label.amount")} *`}
              min={0}
              step={0.01}
              value={(priceValue && priceValue.toString()) || ""}
              onChange={(value) => {
                handleCost(acceptOnlyValidInput(value, priceValue));
              }}
              prefix={moneyFormat}
            />
          )}
        </InlineStack>

        {!isOrderValue && (
          <Checkbox
            checked={isCumulative}
            onChange={toggleCumulativeShipping}
            label={cms("label.chargeCumulative")}
            helpText={cms("modal.offer.add.section.detail.caption.chargeAggregateShipping")}
          />
        )}
      </BlockStack>
    </Card>
  );
};

RenderOfferDetail.propTypes = renderDetail.type;

export default RenderOfferDetail;
